module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booking-summary"
  }, [_c('div', {
    staticClass: "booking-summary__block"
  }, [_c('div', {
    staticClass: "booking-summary__text"
  }, [_c('div', [_c('strong', {
    staticClass: "booking-summary-text--smaller"
  }, [_vm._v("\n                    " + _vm._s(_vm.header) + "\n                ")]), _vm._v(" "), (!_vm.loading && _vm.shouldOfferAlternatives) ? _c('small', [_vm._v("\n                    You can still make an enquiry for your chosen time if you wish, but do please note that " + _vm._s(_vm.venue.name) + " appears to be full at the time you selected.\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.venue.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.pax) + " people")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.DateService.friendlyDate(_vm.date)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.type.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.times.getFriendlyStartTime()) + " - " + _vm._s(_vm.times.getFriendlyEndTime()))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "title": "Change Details"
    },
    on: {
      "click": _vm.changeDetails
    }
  }, [_vm._v("« Change Details")]), _vm._v(" "), (!_vm.loading && _vm.shouldOfferAlternatives) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.findAlternatives
    }
  }, [_vm._v("See Alternatives")]) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? [(_vm.preorderPaymentMsg) ? _c('div', {
    staticClass: "booking-summary-offers booking-summary-callout booking-summary-callout--warning"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.preorderPaymentMsg)
    }
  })]) : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e7fbe9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookingSummary.vue
// module id = 592
// module chunks = 0